  /*
///////////////////////////// Create tests for

signup
lost password invalid
lost password
login
resend email verifiy
subscribe
unsubscribe
register
output id to delete

/////////////////////////////
*/

var testlocale = 'en';
var testemail = '';
var testpass = '';

var testnumber = Math.floor((Math.random() * 10000) + 1);;

var test = {
    login : 'Login for: ',
    signup : 'Signup',
    subscribe: 'Subscribed',
    unsubscribe: 'Unsubscribed',
    register: 'Registered',
    verify: 'Send Email Verifaction',
    editname: 'Edit Name',
    editpass: 'Edit Password',
    editemail: 'Edit Email',
    lost: 'Trigger Lost Password:',
}

var terrors = {
    error: 'Error',
    conflict: 'Conflict',
    cookies: 'Cookies',
    newemail: 'Validate New Email',
    activated: 'Already Activated',
}


function unitTests() {

    $(document).on('change', '#testlocale', function(){

        testlocale = $(this).val();

    });


    $('.rt').on('click', function(){


        testemail = $('#testemail').val();
        if (!testemail) {
            testemail = 'admin+'+testnumber+'@ultra.us';
        }

        testpass = $('#testpass').val();
        if (!testpass) {
            testpass = 'testtest';
        }

        var testData = {
            firstname : 'Test '+testnumber,
            lastname : 'Bar',
            email: testemail,
            password: testpass,
            country: 'US',
            birthday: '1985-01-02',
            gender: 'male',
            homeevent: 'miami',
            source: 'unit.tests'
        }


        showResult('Tests Running for ' + testData.email, 'info');


        _utbody.html('');
        passport.logout();

        lostPasswordTest(testData.email)
        .then(function(result) { return signupTest(testData); })
        .then(function(result) { return loginTest(testData); })
        .then(function(result) { return sendVerifyTest(upp_page.verify); })
        .then(function(result) { return lostPasswordTest(testData.email); })
        .then(function(result) { return subscribeTest(); })
        .then(function(result) { return registerTest(testData); })
        .then(function(result) { return unsubscribeTest(); })
        .then(function(result) { return editNameTest(testData); })
        //.then(function(result) { return editEmailTest(testData); })
        //.then(function(result) { return editPasswordTest(testData); })
        .then(function(result) { showResult('Tests Completed', 'success'); $(document).trigger('rebuild');} );

    });


}


function editEmailTest(testData) {

    var newemail = 'gg+'+testnumber+'new@ultra.us';

    var formdata = {
        email: newemail,
        lastname: 'Bar'
    };

    return passport.update(formdata, upp_page.change_email, testlocale)
    .fail(function(jqXHR, textStatus, error){

        log(jqXHR.status, textStatus, error);
        var error = terrors.error;
        if (jqXHR.status == 401) {
        } else if (jqXHR.status == 0) {
            error = terrors.emailchange;
        } else if (jqXHR.status == 409) {
            error = terrors.conflict;
        } else {
            error = terrors.cookies;
        }
        var fail = $.parseHTML(testResult(test.editemail+' '+error,0));
        _utbody.append(fail);

    })
    .done(function(data, textStatus, jqXHR){

        var good = $.parseHTML(testResult('Requested change email to: '+formdata.email,1));
        _utbody.append(good);

    })

}

function editPasswordTest(testData) {

    var formdata = {
        password: 'newpass123'
    };

    return passport.update(formdata, upp_page.change_email, testlocale)
    .fail(function(jqXHR, textStatus, error){

        var error = terrors.error;
        if (jqXHR.status == 401) {
        } else if (jqXHR.status == 409) {
            error = terrors.conflict;
        } else {
            error = terrors.cookies;
        }
        var fail = $.parseHTML(testResult(test.editpass+' '+error,0));
        _utbody.append(fail);

    })
    .done(function(data, textStatus, jqXHR){

        var passData = {
            email: testData.email,
            password: formdata.password,
        }

        loginTest(passData);

        var good = $.parseHTML(testResult('Changed password to: "'+formdata.password+'"',1));
        _utbody.append(good);

    })

}


function editNameTest(testData) {

    var newname = 'Modded '+testData.firstname;

    var formdata = {
        firstname: newname,
    };

    return passport.update(formdata, upp_page.change_email, testlocale)
    .fail(function(jqXHR, textStatus, error){

        var error = terrors.error;
        if (jqXHR.status == 401) {
        } else if (jqXHR.status == 409) {
            error = terrors.conflict;
        } else {
            error = terrors.cookies;
        }
        var fail = $.parseHTML(testResult(test.editname+' '+error,0));
        _utbody.append(fail);

    })
    .done(function(data, textStatus, jqXHR){

        var good = $.parseHTML(testResult('Changed firstname from: "'+testData.firstname+'"" to "'+newname+'"',1));
        _utbody.append(good);

    })

}



function subscribeTest() {

    return passport.subscribe('miami')
    .fail(function(jqXHR, textStatus, error){
        var error = terrors.error;
        if (jqXHR.status == 401) {
        } else if (jqXHR.status == 409) {
            error = terrors.conflict;
        } else {
            error = terrors.cookies;
        }
        var fail = $.parseHTML(testResult(test.subscribe+' '+error,0));
        _utbody.append(fail);

    })
    .done(function(data, textStatus, jqXHR){

        var good = $.parseHTML(testResult(test.subscribe+' to miami',1));
        _utbody.append(good);

    })

}


function unsubscribeTest() {

    return passport.unsubscribe('miami')
    .fail(function(jqXHR, textStatus, error){

        var error = terrors.error;
        if (jqXHR.status == 401) {
        } else if (jqXHR.status == 409) {
            error = terrors.conflict;
        } else {
            error = terrors.cookies;
        }
        var fail = $.parseHTML(testResult(test.unsubscribe+' '+error,0));
        _utbody.append(fail);

    })
    .done(function(data, textStatus, jqXHR){

        var good = $.parseHTML(testResult(test.unsubscribe+' to miami',1));
        _utbody.append(good);

    })

}

function registerTest(testData) {

    return passport.register('miami-2015')
    .fail(function(jqXHR, textStatus, error){

        var error = terrors.error;
        if (jqXHR.status == 401) {
        } else if (jqXHR.status == 409) {
            error = terrors.conflict;
        } else {
            error = terrors.cookies;
        }
        var fail = $.parseHTML(testResult(test.register+' '+error,0));
        _utbody.append(fail);

    })
    .done(function(data, textStatus, jqXHR){

        var good = $.parseHTML(testResult(test.register+' for miami-2015',1));
        _utbody.append(good);

    })

}


function sendVerifyTest(path) {

    return passport.sendVerify(path, testlocale)
    .fail(function(jqXHR, textStatus, error){
        var error = terrors.error;
        if (jqXHR.status == 401) {
        } else if (jqXHR.status == 409) {
            error = terrors.conflict;
        } else {
            error = terrors.cookies;
        }
        var fail = $.parseHTML(testResult(test.verify+' '+error,0));
        _utbody.append(fail);
    })
    .done(function(data, textStatus, jqXHR){

        var good = $.parseHTML(testResult(test.verify,1));
        _utbody.append(good);

    })

}


function loginTest(testData) {

    return passport.login(testData.email,testData.password)
    .fail(function(jqXHR, textStatus, error){
        var error = terrors.error;
        if (jqXHR.status == 401) {
        } else if (jqXHR.status == 409) {
            error = terrors.conflict;
        } else {
            error = terrors.cookies;
        }
        var fail = $.parseHTML(testResult(test.login+' '+error+' '+testData.email,0));
        _utbody.append(fail);
    })
    .done(function(data, textStatus, jqXHR){

        $(document).trigger('rebuild');

        var good = $.parseHTML(testResult(test.login+' '+testData.email,1));
        _utbody.append(good);

    })

}



function lostPasswordTest(email) {


    return passport.sendReset(email, upp_page.reset_password, upp_page.signup, testlocale)
    .fail(function(jqXHR, textStatus, error){

        var error = terrors.error;
        if (jqXHR.status == 401) {
        } else if (jqXHR.status == 409) {
            error = terrors.conflict;
        } else {
            error = terrors.cookies;
        }
        var fail = $.parseHTML(testResult(test.lost+' '+error+' for '+email,0));
        _utbody.append(fail);

    })
    .done(function(data, textStatus, jqXHR){

        var good = $.parseHTML(testResult(test.lost+' for '+email,1));
        _utbody.append(good);

    })

}

function signupTest(testData) {

    return passport.create(testData)
    .fail(function(jqXHR, textStatus, error){
        $(document).trigger('rebuild');

        var error = terrors.error;
        if (jqXHR.status == 401) {
        } else if (jqXHR.status == 409) {
            error = terrors.conflict;
        } else {
            error = terrors.cookies;
        }
        var fail = $.parseHTML(testResult(test.signup+' '+error,0));
        _utbody.append(fail);


    })
    .done(function(data, textStatus, jqXHR){

        var good = $.parseHTML(testResult(test.signup+' account created for '+testData.email+' : '+testData.password,1));
        _utbody.append(good);

    });
}



function testResult(test,status) {

    if (status === 1) {
        status = 'pass';
    } else {
        status = 'fail';
    };

    return '<tr class="'+status+' test"><td><p>'+test+'</p></td><td align="center"><strong>'+status.toUpperCase()+'</strong></td></tr>';
}
